<template>
  <div id="app">
    
  <div class="overlay"></div>
    <router-view/>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

import Store from "./store"

export default {
  name: "app",
  data: function() {
    return {
      // username:''
    };
  },
  mounted: function() {
    
  },
  methods: {
    onLogout: function() {
      console.log("logout");
      const self = this;
      const params = new URLSearchParams();
      this.$store.dispatch("logout");
      this.$axios
        .post(`/srv/api/logout`, params, {
          withCredentials: true
        })
        .then(response => {
          const data = response.data;
          if (data.status !== undefined) {
            if (data.status === "success") {
              console.log("success");
              self.$router.push("/login");
            } else {
              console.log("error");
              self.$router.push("/login");
            }
          } else {
            console.log("error");
            self.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    childID() {
      return this.$store.state.childID;
    },
    username() {
      return this.$store.state.loginID;
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    isConfirmed() {
      return this.$store.state.isConfirmed;
    },
    loginType() {
      return this.$store.state.loginType;
    }
  },
};
</script>
<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
